import { PAUSE, SET_OVER, UPDATE_STATS, SET_SIZE, SET_CLEARED, SET_SECS, SET_BONUS } from './actions';
import * as f from '../logic';
import _ from 'lodash';
import { dbdel } from '../../HOME/utils';
import { HELPED_KEY } from '../const';

export default (state = {}, action) => {
  switch (action.type) {
    case PAUSE:
      return { ...state, paused: action.on };
    case SET_SIZE:
      return { ...state, size: action.size };
    case SET_CLEARED:
      return { ...state, cleared: action.count };
    case SET_BONUS:
      return { ...state, bonus: action.bonus };
    case SET_OVER:
      return { ...state, over: action.over };
    case UPDATE_STATS:
      return onUpdateStats(state, action.stats);
    case SET_SECS:
      return { ...state, secs: action.secs };
    case HELPED_KEY:
      return { ...state, helped: true };
    default:
      return state;
  }
};

function onUpdateStats(state, stats) {
  if (!stats) {
    dbdel(f.statsKey(state));
    stats = { plays: 0, aggSecs: 0, aveSecs: 0, bestSecs: 0, aggScore: 0, aveScore: 0, bestScore: 0 };
  } else {
    let { plays, aggSecs, bestSecs, aggScore, bestScore } = stats;

    const aveSecs = plays === 0 ? 0 : _.round((aggSecs || 0) / plays);
    const aveScore = plays === 0 ? 0 : _.round((aggScore || 0) / plays);

    stats = { plays, aggSecs, aveSecs, bestSecs, aggScore, aveScore, bestScore };
  }

  return { ...state, stats };
}
